import "@/style/main.scss";
import zepto from "@/utils/zepto.min";
import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import router from "@/router";

import axios from "axios";

!window.Promise && (window.Promise = Promise);

//正式地址
const contentId = "4944";

// 埋点
try {
  initWebMd({});
  webCallBack({
    cp: gxyAccessToken, // 自定义 cookie
    channel_name: "zhuanti", // 专题
  });
} catch (error) {}

function setWXConfig(res) {
  const WX_APP_ID = "wxfde72d83dd939a05";

  const shareData = {
    title: "“让人民评价——风雨同舟·云守护你”三级联动留言互助平台", // 标题
    desc: "",
    imgUrl: "https://h5.gxrb.com.cn/front/2026/fytzhzpt/share.png", // 缩略图
    link: window.location.href, //分享链接
  };
  // 设置新广西云普通分享
  setShare(shareData);
  if (res.data && res.data.noncestr) {
    wx.config({
      debug: false,
      appId: WX_APP_ID, // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: [
        "onMenuShareAppMessage",
        "onMenuShareTimeline",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone",
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "openLocation",
        "getLocation",
      ], // 必填，需要使用的JS接口列表
      openTagList: ["wx-open-launch-weapp"],
    });
    wx.ready(() => {
      console.log("wx ready");
      wx.onMenuShareAppMessage(shareData);
      wx.onMenuShareTimeline(shareData);
      wx.onMenuShareQQ(shareData);
      wx.onMenuShareWeibo(shareData);
      wx.onMenuShareQZone(shareData);
      wx.updateAppMessageShareData(shareData);
      wx.updateTimelineShareData(shareData);
    });
  }
}

function serviceGetShareSignature() {
  var shareurl = window.location.href.split("#")[0];
  $.ajax({
    url: `https://zuul.gxrb.com.cn/api-newtime/getSignature/GetSignature/?shareMTurl=${encodeURIComponent(
      shareurl
    )}`,
    success: function success(res) {
      setWXConfig(res);
    },
  });
}

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.prototype.axios = axios;
Vue.prototype.zepto = zepto;
Vue.prototype.serviceGetShareSignature = serviceGetShareSignature;
Vue.prototype.contentId = contentId;
// router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0);
//   next();
// });
/* eslint-disable no-new */
new Vue({
  el: "app",
  router,
  render(h) {
    return this.$route.meta.keepAlive ? (
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    ) : (
      <router-view></router-view>
    );
  },
  data() {
    return {};
  },
  created() {
    this.serviceGetShareSignature();
  },
  methods: {},
});
